import { createBrowserRouter, Navigate } from "react-router-dom";

import AppLayout from "./layout/AppLayout";
import OverviewPage from "./pages/overview/OverviewPage";
import HistoryPage from "./pages/history/HistoryPage";
import AnalysisPage from "./pages/analysis/AnalysisPage";
import LoginPage from "./pages/auth/LoginPage";
import SetupPasswordPage from "./pages/auth/SetupPasswordPage";
import GaragePage from "./pages/garage/GaragePage";
import CarDetailPage from "./pages/garage/CarDetailPage";
import FuelStationsPage from "./pages/fuel-stations/FuelStationsPage";
import AccountPage from "./pages/account/AccountPage";
import AccountSettingsPage from "./pages/account/AccountSettingsPage";
import RequireAuth from "./auth/RequireAuth";

export const router = createBrowserRouter([
  // Public auth routes — outside AppLayout so they don't render the tab
  // bar (which queries protected endpoints).
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/setup", element: <SetupPasswordPage /> },

  // Everything else requires a logged-in user.
  {
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { path: "/", element: <OverviewPage /> },
      { path: "/history", element: <HistoryPage /> },
      { path: "/garage", element: <GaragePage /> },
      { path: "/garage/:id", element: <CarDetailPage /> },
      { path: "/fuel-stations", element: <FuelStationsPage /> },
      { path: "/analysis", element: <AnalysisPage /> },
      { path: "/account", element: <AccountPage /> },
      { path: "/account/settings", element: <AccountSettingsPage /> },
      // Anything we don't recognize → home. The backend SPA catch-all
      // serves index.html for unknown paths; the client-side router
      // decides what to do with them.
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
